import { ajax } from '@/api/ajax'

//1、课堂测验分页查询
export const reqClassRoomTestList = (paramets) => ajax(`/ClassroomTest/jxClassroomTest/Tjlist`, paramets)

//2、课堂测验添加
export const reqClassRoomTestAdd = (paramets) => ajax(`/ClassroomTest/jxClassroomTest/add`, paramets, 'post')

//2、课堂测验编辑
export const reqClassRoomTestEdit = (paramets) => ajax(`/ClassroomTest/jxClassroomTest/edit`, paramets, 'put')

//3、课堂测验通过id删除
export const reqClassRoomTestDel = (paramets) => ajax(`/ClassroomTest/jxClassroomTest/delete`, paramets, 'delete')

//4、课堂测验通过id查询
export const reqClassRoomTestDetailById = (paramets) => ajax(`/ClassroomTest/jxClassroomTest/queryById_Test`, paramets)

//5、课堂测验批量删除
export const reqClassRoomTestDelBatch = (paramets) => ajax(`/ClassroomTest/jxClassroomTest/deleteBatch`, paramets, 'delete')

//7、课堂测验通过id获取试题
export const reqClassRoomTestListById = (paramets) => ajax(`/ClassroomTest/jxClassroomTest/queryById_Test`, paramets)



// WEBPACK FOOTER //
// ./src/api/kzActivity/test.js